import {JourSemaine} from '../../../../../enums/client/jour-semaine.enum';

/** Jour de la semaine et ses libellés d'affichage. */
export interface JourSemaineItem {

  id: JourSemaine;

  libelle: string;

  libelleCourt: string;
}

export const JOUR_SEMAINE_LIST: JourSemaineItem[] = [
  {id: JourSemaine.LUNDI, libelle: 'Lundi', libelleCourt: 'Lun'},
  {id: JourSemaine.MARDI, libelle: 'Mardi', libelleCourt: 'Mar'},
  {id: JourSemaine.MERCREDI, libelle: 'Mercredi', libelleCourt: 'Mer'},
  {id: JourSemaine.JEUDI, libelle: 'Jeudi', libelleCourt: 'Jeu'},
  {id: JourSemaine.VENDREDI, libelle: 'Vendredi', libelleCourt: 'Ven'},
  {id: JourSemaine.SAMEDI, libelle: 'Samedi', libelleCourt: 'Sam'},
  {id: JourSemaine.DIMANCHE, libelle: 'Dimanche', libelleCourt: 'Dim'}
];
